import { useBaseMutation } from "../baseMutation";
import { RestError } from "@maven-rest/common/HttpRequest";
import { SignDocumentWithSignerTokenRequest, SignDocumentWithSignerTokenResponse } from "@maven-rest/docs/DocumentSign.dto";
import { DocumentSignerUrl } from "@maven-rest/docs/DocumentSigner.url";

export function useSignDocumentWithSignerTokenMutation(req: {
  onSuccess: (data: SignDocumentWithSignerTokenResponse, variables: SignDocumentWithSignerTokenRequest, context: unknown) => void;
  onError: (
    error: RestError<{ id: string; page: string; invalid?: string; missing?: string }>,
    variables: SignDocumentWithSignerTokenRequest,
    context: unknown
  ) => void;
}) {
  return useBaseMutation({
    fnOption: {
      url: DocumentSignerUrl.signDocumentWithSignerToken,
    },
    onSuccess: req.onSuccess,
    onError: req.onError,
  });
}
